<template>
  <transition name="modal">
    <div class="modal-overlay">
      <div class="modal-wrapper showSweetAlert visible" data-animation="pop">

        <em class="sa-icon sa-error fa fa-warning"></em>
        <h2 class="modal-title">There is a problem</h2>
        <p class="modal-paragraph">
          Commercial addresses are not allowed as an investor's residential
          addresses.
        </p>

        <fieldset class="checkbox c-checkbox override-row">
          <label>
            <input
              type="checkbox"
              name="allowCommercialAddress"
              v-model="allowed">
            <span class="fa fa-check"></span>
            Allow commercial address as residential
          </label>
        </fieldset>

        <fieldset v-if="allowed" class="form-group override-row">
          <label for="commercialOverrideComment">
            Override verified by
            <small class="text-muted">
              (who approved this and how it was verified, e.g. Google Maps)
            </small>
          </label>
          <textarea
            id="commercialOverrideComment"
            class="form-control"
            rows="2"
            v-model="comment"
            placeholder="e.g. Verified via Google Maps by Jane Admin">
          </textarea>
        </fieldset>

        <div class="modal-buttons">
          <div class="row">
            <div class="col-md-12 text-center">
              <button class="btn btn-default btn-lg" @click="cancel">Cancel</button>
              <button
                class="btn btn-primary btn-lg btn-accept"
                :disabled="!canSave"
                @click="confirm">
                Save with override
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'commercialAddressOverride',
    data() {
      return {
        allowed: false,
        comment: '',
      };
    },
    computed: {
      canSave() {
        return this.allowed && this.comment.trim().length > 0;
      },
    },
    methods: {
      confirm() {
        if (!this.canSave) return;
        this.$emit('confirm', this.comment.trim());
      },
      cancel() {
        this.$emit('cancel');
      },
    },
  };
</script>

<style scoped>
  .modal-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow-y: auto;
    padding: 15px;
    -webkit-overflow-scrolling: touch;
  }
  .modal-wrapper {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    display: block;
    margin: auto;
    max-height: calc(100vh - 30px);
    overflow-y: auto;
  }
  .modal-wrapper p {
    font-size: 16px;
    text-align: center;
  }
  .modal-title {
    color: #f05050;
    text-align: center;
  }
  .override-row {
    text-align: left;
    padding: 0 30px;
    margin-top: 10px;
  }
  .modal-buttons {
    border-top: 1px solid #e5e5e5;
    position: relative;
    padding: 15px;
    margin-top: 30px;
  }
  .modal-buttons .btn {
    margin: 0 5px;
  }
</style>



// WEBPACK FOOTER //
// CommercialAddressOverride.vue?53f0aef1